var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.722,
    height: 22.178,
    viewBox: "0 0 21.722 22.178",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6912",
    "data-name": "Path 6912",
    d: "M132.446,22.256H127.67v-.221q0-3.9,0-7.8a5.54,5.54,0,0,0-.237-1.762,2.023,2.023,0,0,0-2.373-1.493,2.628,2.628,0,0,0-2.092,2.638c0,.921,0,1.842,0,2.763v5.863H118.2V7.258h4.763V9.139c.146-.194.26-.353.381-.506a4.329,4.329,0,0,1,3.027-1.694,5.381,5.381,0,0,1,3.229.56,5.138,5.138,0,0,1,2.441,3.14,8.743,8.743,0,0,1,.406,2.628c.013,2.963.007,5.925.007,8.888,0,.028,0,.056-.006.1M114.265,5.264a8.74,8.74,0,0,1-.861.148,2.626,2.626,0,0,1-2.192-1.1A2.671,2.671,0,0,1,112.758.157a2.852,2.852,0,0,1,2.077.28,2.647,2.647,0,0,1,1.251,2.514,2.492,2.492,0,0,1-1.82,2.313m1.509,16.987h-4.746v-15h4.746Z",
    transform: "translate(-110.732 -0.078)",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.70facc4abd3d4de46acd6d8078ccfb58.svg";
export { ForwardRef as ReactComponent };